import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './changelog.action';

@Injectable({ providedIn: 'root' })
export class ChangelogTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                title_nl: '', 
                accesses: null, 
                tags: null,
                statuses: null, //Null for select list
                created_at: '', 
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    versionId: string;
    accesses = [];
    tags = [];
    statuses = [
        {id: "1", name: 'CHANGELOG.active'},
        {id: "0", name: 'CHANGELOG.inactive'}
    ];
    hasFilter = false;
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'title_nl', name: 'CHANGELOG.title', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'accesses', name: 'CHANGELOG.applies-to', sortable: false, hasFilter: true, filter: "select", options: 'accesses', options_id: "id", options_label: "name" },
                { prop: 'tags', name: 'CHANGELOG.tags', sortable: false, hasFilter: true, filter: "select", options: 'tags', options_id: "id", options_label: "name" },
                { prop: 'is_active', name: 'COMMON.status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name" },
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords({version: this.versionId}));
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            title_nl: '', 
            accesses: null, 
            tags: null,
            statuses: null, 
            created_at: '', 
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}